var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7 0C3.14014 0 0 3.14014 0 7C0 10.8599 3.14014 14 7 14C10.8599 14 14 10.8599 14 7C14 3.14014 10.8599 0 7 0ZM7 12C4.24316 12 2 9.75684 2 7C2 4.24316 4.24316 2 7 2C9.75684 2 12 4.24316 12 7C12 9.75684 9.75684 12 7 12ZM10 7C10 7.55225 9.55225 8 9 8H8V9C8 9.55225 7.55225 10 7 10C6.44775 10 6 9.55225 6 9V8H5C4.44775 8 4 7.55225 4 7C4 6.44775 4.44775 6 5 6H6V5C6 4.44775 6.44775 4 7 4C7.55225 4 8 4.44775 8 5V6H9C9.55225 6 10 6.44775 10 7Z",
  fill: "white"
})));
export { SvgPlus as ReactComponent };
export default __webpack_public_path__ + "assets/icons/plus.51c84f.svg";